export default __webpack_public_path__ + "static/media/card-w-about@3x.184a7ed2.png";